import { DatePicker, Table, TableColumn, Loading } from 'element-ui';
import Vue from 'vue';
Vue.use(DatePicker);
Vue.component('ElTable', Table);
Vue.component('ElTableColumn', TableColumn);
Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;
